import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Button, Grid, Stack, Typography,
} from '@mui/material';
import { saveSiteConfiguration } from '../../../../features';
import { InfoChip } from '../../../../components/CustomChip';
import useToggle from '../../../../hooks/useToggle';
import { openSnackbar } from '../../../../features/SnackBar/snackBarSlice';
import { SelectBox } from '../../../../components/FormComponents';
import useStyles from '../../../../hooks/useStyles';
import styles from '../../../../layouts/pages/style';

function EmailAlertSettingsCard() {
  const dispatch = useDispatch();
  const siteConfiguration = useSelector((state) => state.siteConfiguration.data);

  const [alertFreq, setAlertFreq] = useState('');
  const [enableSave, setEnableSave] = useToggle();

  useEffect(() => {
    if (siteConfiguration?.emailFrequency) {
      setAlertFreq(siteConfiguration.emailFrequency);
    }
  }, [siteConfiguration]);

  const handleSubmit = () => {
    const emailFrequency = alertFreq;

    dispatch(saveSiteConfiguration({ emailFrequency }))
      .then(() => {
        dispatch(
          openSnackbar({
            open: true,
            message: 'Successfully Updated !',
            type: 'success',
          }),
        );
      });

    setEnableSave(false);
  };

  const handleFreqChange = (e) => {
    setAlertFreq(e.target.value);
    if (!enableSave) setEnableSave(true);
  };

  const freqMsg = {
    daily: 'Email will be sent daily at 8 PM IST',
    weekly: 'Email will be sent Weekly on Monday at 8 PM IST',
    monthly: 'Email will be sent Monthly on 1st Date at 8 PM IST',
  };

  const classes = useStyles(styles)();

  return (
    <Box className={classes.cardStyles} sx={{ width: '100%' }}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography sx={{ fontSize: '22px', fontWeight: 500 }}>
          Email Alert
        </Typography>
        {enableSave && <Button size="small" variant="outlined" onClick={handleSubmit}>Save</Button>}
      </Stack>

      {/* Content */}
      <Grid container gap={2}>
        <InfoChip icon label={freqMsg[alertFreq] || ''} />

        <Grid item container display="flex" justifyContent="space-between" alignItems="flex-end">
          <Grid item xs={8}>
            <Typography>Alerts</Typography>
            <Typography fontSize="small">Choose the time frame for email alerts: daily, weekly, or monthly, delivered at 8 PM IST.</Typography>
          </Grid>

          <Grid item xs={3}>
            <SelectBox
              value={alertFreq}
              onChange={handleFreqChange}
              data={[
                { value: 'daily', name: 'Daily' },
                { value: 'weekly', name: 'Weekly' },
                { value: 'monthly', name: 'Monthly' },
              ]}
            />
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EmailAlertSettingsCard;
